import React ,{useState} from 'react';
import './Language.scss';
import {CookieLanguageInfoEnum, LanguagesEnum, LanguagesNavigationEnum} from "../../../helpers/enums";
import {getCookie} from "../../../helpers/helpers";
import { Dropdown } from "react-bootstrap";

const SwitchLanguage = (props) => {
  const langTitle = LanguagesNavigationEnum[props.language.substr(0,2)];
  return (
    <li className={props.currentLanguage === props.language ? "active" : "deactive"}>
      <a className="dropdown-item paragraph-main-fs8 font-color-1" data-toggle="modal" href="#"
        onClick={() => {
          props.changeLanguage(props.language);
          props.setLanguage(props.language);
        }}>{langTitle}
      </a>
    </li>
  )
};
const Language = (props) => {
    let [language, setLanguage] = useState(getCookie(CookieLanguageInfoEnum.name));
    let languageTitle = language.substr(0,2);
    return (
      props.isMobile ? (
        <Dropdown className="language dropup" id="nav-language">
          <Dropdown.Toggle as="button" type="button" className="" id="dropdownMenuButtonLanguage" aria-haspopup="true" aria-expanded="false">
            <span>{LanguagesNavigationEnum[languageTitle]}</span><i className="gc-icon-functional-chevron-down" aria-hidden="true"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul">
            <SwitchLanguage
              currentLanguage = {language}
              language={LanguagesEnum.it}
              changeLanguage = {props.changeLanguage}
              setLanguage={setLanguage}
            />
            <SwitchLanguage
              currentLanguage = {language}
              language={LanguagesEnum.en}
              changeLanguage = {props.changeLanguage}
              setLanguage={setLanguage}
            />
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Dropdown className="language dropdown" id="language">
          <Dropdown.Toggle as="button" type="button" className="gcap-cta header-link header-link-icon header-link-font-color-2" id="dropdownMenuButtonLanguage" aria-haspopup="true" aria-expanded="false">
            <span>{LanguagesNavigationEnum[languageTitle]}</span><i className="gc-icon-functional-chevron-down" aria-hidden="true"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul">
            <SwitchLanguage
              currentLanguage = {language}
              language={LanguagesEnum.it}
              changeLanguage = {props.changeLanguage}
              setLanguage={setLanguage}
            />
            <SwitchLanguage
              currentLanguage = {language}
              language={LanguagesEnum.en}
              changeLanguage = {props.changeLanguage}
              setLanguage={setLanguage}
            />
          </Dropdown.Menu>
        </Dropdown>
      )
    );
}

Language.propTypes = {};

export default Language;
